module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"click_to_select":"Click to select","click_to_edit":"Click to edit"},"zh":{"click_to_select":"點此選擇","click_to_edit":"點此編輯"}}')
  delete Component.options._Ctor
}
